import {
 DatahubEntity,
 FirstplayAction,
 IFirstplaySchema,
 IDefaultSchema,
 DATA_VERSION,
 CaptureEventData,
 CaptureEvent
} from 'src/interfaces/Datahub';

import ApplicationService from 'src/services/ApplicationService';

class Firstplay {
  private defaultData: IDefaultSchema;

  constructor(defaultData: IDefaultSchema) {
    this.defaultData = defaultData;
  }

  measure(captureEvent: CaptureEvent<FirstplayAction>) {
    
    const event: IFirstplaySchema = {
      ...this.defaultData,
      mediaPosition: ApplicationService.player?.currentTime || 0
    };

    const data: CaptureEventData = {
      event,
      data_version: DATA_VERSION['2.0']
    };

    captureEvent(DatahubEntity.FIRSTPLAY, FirstplayAction.MEASURE, data);
  }

} export default Firstplay;